// extracted by mini-css-extract-plugin
export default {"admin_page":"panel_admin_page__N-sPU","admin_page_right":"panel_admin_page_right__x1GjY"};